import { useLocation } from "react-router-dom";

import {
  appointmentDetailRegex,
  backordersRegex,
  customersRegex,
  dealerDocumentationRegex,
  dealerLicenseOverviewRegex,
  devicesRegex,
  dmsv3CustomQueriesRegex,
  dmsv3SettingsRegex,
  leadsRegex,
  locationLicenseOverviewRegex,
  manufacturerRegex,
  newsRegex,
  unlinkedExactLicensesRegex,
  usersRegex,
  warrantyRegex
} from "components/NavBar/routes";

const pathsToHideDealerLocationsDropdowns = [
  appointmentDetailRegex,
  backordersRegex,
  customersRegex,
  dealerDocumentationRegex,
  dealerLicenseOverviewRegex,
  devicesRegex,
  dmsv3CustomQueriesRegex,
  dmsv3SettingsRegex,
  leadsRegex,
  locationLicenseOverviewRegex,
  manufacturerRegex,
  newsRegex,
  unlinkedExactLicensesRegex,
  usersRegex,
  warrantyRegex
];

export const useHideDealerLocationsDropdown = () => {
  const location = useLocation();
  return pathsToHideDealerLocationsDropdowns.some(path => path.test(location.pathname));
};
